import { inputTypes, dispConvertType } from "@/Strings/Constant";
import jalali from "moment-jalaali";

export default {
  methods: {
    displayValue(def, value) {
      if (!def || !def.inputType) return this.calcTextValue(value);
      if (value === "" || value === undefined) return "-";
      const inputType = def.inputType.name;
      if (def.lookup) {
        if (inputType === inputTypes.DEF) {
          return this.$t(`${value}.Label`);
        }
        return this.getLookUp(def, value);
      }
      const lang = this.$store.state.locale === "fa-IR" ? "fa" : "en";
      switch (inputType) {
         case inputTypes.DATEANDTIME:
  return value
    ? lang === "fa"
      ? jalali(value).format("jYYYY/jMM/jDD HH:mm:ss")
      : jalali(value).format("YYYY/MM/DD HH:mm:ss")
    : "-";
        case inputTypes.LOCAL_DATE:
          return value
            ? lang === "fa"
              ? jalali(value).format("jYYYY/jMM/jDD")
              : jalali(value).format("YYYY/MM/DD")
            : undefined;
        case inputTypes.GLOBAL_DATE:
          return value && jalali(value).format("YYYY/MM/DD");
        case inputTypes.TEXT:
          if (def.displayConvertType) {
            switch (def.displayConvertType.name) {
              case dispConvertType.DIGITS_TO_MONEY:
                return value && Math.round(Number(value)).toLocaleString();
              case dispConvertType.PERCENT_TO_NUMBER:
                if (value) {
                  const str = value.toString();
                  const length =
                    str.includes(".") && str.split(".").pop()?.length;
                  return parseFloat(Number(value) * 100).toFixed(
                    length - 2 < 0 ? 0 : length - 2,
                  );
                }
                break;
              case dispConvertType.YEAR_TO_DATE:
                return (value / 365).toFixed();

              case dispConvertType.REMOVE_NUM_FROM_STRING:
                if (value) {
                  // فقط اعداد و خط تیره‌های داخل براکت را حذف می‌کند
                  const regex = /\[[0-9\-]+\]/g;
                  if (!value) return "";
                  let replacedString = String(value).replace(regex, " ");
                  return replacedString.replace(/ +/g, " ").trim();
                }

              default:
                return value;
            }
          }
          return value;
        // remove this two type later
        case inputTypes.MONEY:
          return value && Number(value).toLocaleString();
        case inputTypes.Percent:
          return value && Number(value) * 100;
        default:
          return this.calcTextValue(value);
      }
    },

    calcTextValue(value) {
      if (typeof value !== "string") {
        return value;
      }
      const regexPattern = /\{([^}]*)\}/;
      if (regexPattern.test(value)) {
        const match = value.match(regexPattern);
        const extractedText = match[1];
        const replacement = this.$t(extractedText);
        value = value.replace(regexPattern, replacement);
        return value;
      } else {
        return value;
      }
    },
    isJsonArray(str){
      try {
        const value = JSON.parse(str);
        return Array.isArray(value);
      } catch {
        return false;
      }
    },
    getLookUp(prop, item) {      
      if (this.$attrs.items) {        
        if(this.isJsonArray(item)) item = JSON.parse(item);
        if (Array.isArray(item)) {
          const arr = this.getUnique(this.$attrs.items);
          return arr
            .filter((c) => item.includes(c.ID))
            .map((c) => c.DisplayText)
            .join(" , ");
        }
        return (this.$attrs.items.find((value) => value.ID === item) || {})
          .DisplayText;
      }
      const lookupValue = this.$abr.api.resolveLookup(prop.lookup, item) || {};      
      if (Array.isArray(lookupValue))
        return lookupValue.map((c) => c.DisplayText).join(" , ");      
      return lookupValue.DisplayText;
    },
    getUnique(array) {
      const uniqueArray = [];
      for (let value of array) {
        if (
          uniqueArray.findIndex((a) => a.DisplayText === value.DisplayText) ===
          -1
        ) {
          uniqueArray.push(value);
        }
      }
      return uniqueArray;
    },
  },
};
